import React from 'react';
import { Trends } from 'src/features/MM/components/templates/Trends';
import { Page } from '../../components/molecules/Page';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const TrendsPage: React.FC = () => {
  return (
    <Page
      pageTitle="Trends"
      filterBar={<FilterBar includeAggregation includeDimension />}
      extraButtons={<GenAIActionButtons />}>
      <Trends />
    </Page>
  );
};
